<script setup>
import { computed } from "vue";
import {
	Label,
	Input,
	ColorPicker,
	Textarea,
	Select,
	MediaUploaderButton,
} from "@components";

import { useService } from "@store/service";
const $service = useService();

import { useServiceItem } from "@store/serviceItem";
const $serviceItem = useServiceItem();

import { useSettings } from "@store/settings";
const $settings = useSettings();

const getCategories = computed(() => {
	return $service.getCategories
		.filter((cat) => cat.category_id)
		.map((category) => {
			return {
				label: category.name,
				value: category.category_id,
			};
		});
});

const createCategory = async (categoryName) => {
	if (categoryName == "Uncategorised" || categoryName == "uncategorised")
		return Toast.warning(
			'Category name cannot be "Uncategorised" or "uncategorised"'
		);

	// check "Uncategorised" category priority
	const uncategorised = $service.getCategories.find(
		(cat) => cat.name == "Uncategorised"
	);

	let maxPriority = 0;
	let newCategories = [];

	// if uncategory priority is 999, remove it and then find the max priority
	if (uncategorised && uncategorised.meta.priority == 999) {
		newCategories = $service.getCategories.filter(
			(cat) => cat.name != "Uncategorised"
		);
		maxPriority = newCategories.length
			? Math.max(...newCategories.map((cat) => Number(cat.meta.priority)))
			: 0;
	} else {
		newCategories = $service.getCategories;
		maxPriority = newCategories.length
			? Math.max(...newCategories.map((cat) => Number(cat.meta.priority)))
			: 0;
	}

	const response = await $service.updateCategory({
		name: categoryName || "New Category",
		status: "publish",
		meta: {
			color: "#333333",
			priority: maxPriority + 1,
		},
	});

	$serviceItem.service.category_id = response.data.category_id;
};
</script>

<template>
	<div>
		<div v-if="$serviceItem.state.loading" class="flex flex-col gap-5">
			<div class="animate-pulse bg-[#F2F4F7] rounded-md h-[68px] w-full"></div>
			<div class="animate-pulse bg-[#F2F4F7] rounded-md h-[96px] w-full"></div>
			<div class="animate-pulse bg-[#F2F4F7] rounded-md h-[72px] w-full"></div>
			<div class="animate-pulse bg-[#F2F4F7] rounded-md h-[226px] w-full"></div>
		</div>
		<div class="flex flex-col items-center gap-5" v-if="!$serviceItem.state.loading">
			<div class="w-full relative">
				<Label class="flex items-center justify-between">
					<span class="capitalize">
						{{ $settings.labels.service?.singular }} Name
						<div class="text-[#D92D20] inline-block">*</div>
					</span>
					<span class="pr-11 text-sm font-medium">Color</span>
				</Label>
				<Input required v-model="$serviceItem.service.name" :placeholder="`Enter ${String($settings.labels.service?.singular).toLowerCase()} name`" type="text" class="mt-1.5">
					<template #after>
						<ColorPicker v-model="$serviceItem.service.meta.color" borderless></ColorPicker>
					</template>
				</Input>
			</div>
			<div class="w-full">
				<Label>Short Description</Label>
				<Textarea v-model="$serviceItem.service.short_description" :placeholder="`Enter ${String($settings.labels.service?.singular).toLowerCase()} short description`" class="mt-1.5" textareaClass="h-[60px]" />
			</div>

			<div class="w-full">
				<Label>Select Category</Label>
				<Select search searchPlaceholder="Search category" create createLabel="Create new category" @create="createCategory" v-model="$serviceItem.service.category_id" placeholder="Select category" :options="getCategories" class="mt-1.5"></Select>
			</div>
			<div class="w-full">
				<Label>{{ $settings.labels.service?.singular }} Thumbnail</Label>
				<MediaUploaderButton :crop="true" :ratio="80 / 60" name="service_thumbnail_image" v-model="$serviceItem.service.meta.thumbnail_image_url" :dummyData="$serviceItem.service.meta.thumbnail_image_url" dummy class="mt-1.5 w-full" />
				<!-- <MediaUploaderButton name="service_thumbnail_image" v-model="$serviceItem.service.meta.gallery_images" v-model:thumb="$serviceItem.service.meta.thumbnail_image_url" dummy multiple class="mt-1.5 w-full" /> -->
			</div>
		</div>
	</div>
</template>
